import React, { useState, useEffect, useRef } from 'react';
import { HiChevronDown } from 'react-icons/hi';
import { COLORS } from '../utils/colors';
import './ColorSelect.css';

const getHexForColor = (name, colorList) => {
  if (!name) return '#ccc';
  const fromList = colorList?.find(c => c.name.toLowerCase() === name.toLowerCase());
  if (fromList) return fromList.hex;
  return '#94a3b8';
};

const ColorSelect = ({ value, onChange, placeholder = 'Select color', disabled, id, excludeColors = [] }) => {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState('');
  const containerRef = useRef(null);
  const excludeSet = Array.isArray(excludeColors) ? new Set(excludeColors.map(c => String(c).toLowerCase().trim())) : new Set();
  const colors = COLORS;

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const filtered = colors.filter(c => {
    if (search.trim() && !c.name.toLowerCase().includes(search.toLowerCase().trim())) return false;
    const key = c.name.toLowerCase().trim();
    if (excludeSet.size && excludeSet.has(key)) return false;
    return true;
  });
  const displayHex = getHexForColor(value, colors);

  return (
    <div className="color-select" ref={containerRef} id={id}>
      <button
        type="button"
        className={`color-select-trigger ${open ? 'open' : ''} ${disabled ? 'disabled' : ''}`}
        onClick={() => !disabled && setOpen(!open)}
        disabled={disabled}
      >
        <span className="color-select-value">
          {value ? (
            <>
              <span className="color-swatch" style={{ background: displayHex }} />
              <span className="color-name">{value}</span>
            </>
          ) : (
            <span className="color-placeholder">{placeholder}</span>
          )}
        </span>
        <HiChevronDown className="color-select-chevron" />
      </button>

      {open && (
        <div className="color-select-dropdown">
          <input
            type="text"
            className="color-select-search"
            placeholder="Search colors..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            autoFocus
          />
          <div className="color-select-grid">
            {filtered.map((c) => (
              <button
                key={c.name}
                type="button"
                className={`color-select-option ${value === c.name ? 'selected' : ''}`}
                onClick={() => {
                  onChange(c.name);
                  setOpen(false);
                  setSearch('');
                }}
              >
                <span className="color-swatch" style={{ background: c.hex }} />
                <span className="color-name">{c.name}</span>
              </button>
            ))}
            {filtered.length === 0 && (
              <div className="color-select-empty">No matching colors</div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ColorSelect;
